let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e1GXb")).then(() => parcelRequire('ixmdX'));